import styles from './Event.module.scss';
import { DateLabel } from '@components/components/Timeline/components/Primitives/Primitives.js';
import Vimeo from '@components/components/Vimeo/Vimeo';
import React from 'react';
import { Video } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const renderVideoElement = (video, vimeoId) => {
  if (video) {
    return (
      <Video
        autoPlay={false}
        controls
        preload="none"
        title={video.title}
        video={video}
      />
    );
  }
  if (vimeoId) {
    return (
      <Vimeo isAutoplay={false} isMuted videoSize="100%" vimeoId={vimeoId} />
    );
  }
  return null;
};

const VideoEvent = ({
  event: { entryPosition, video, vimeoId },
  date,
  id,
  containerDimension,
  setPulse,
}) => (
  <div
    className={classNames(styles.eventVideoContainer, styles[entryPosition], {
      [styles.isRegularVideo]: video,
      [styles.inContainer]: containerDimension && containerDimension !== 'full',
    })}
    onMouseEnter={() => setPulse(prev => !prev)}
    onMouseLeave={() => setPulse(prev => !prev)}
  >
    {date && (
      <DateLabel className={styles.videoDateLabel} date={date} id={id} />
    )}
    {renderVideoElement(video, vimeoId)}
  </div>
);

VideoEvent.propTypes = {
  containerDimension: PropTypes.string,
  date: PropTypes.string.isRequired,
  event: PropTypes.shape({
    entryPosition: PropTypes.string,
    // exact shape of video object varies
    // eslint-disable-next-line react/forbid-prop-types
    video: PropTypes.object,
    vimeoId: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  setPulse: PropTypes.func,
};

VideoEvent.defaultProps = {
  containerDimension: null,
  setPulse: () => {},
};
export default VideoEvent;
